import { client } from '@cockpitai/lib/api'
import { type Favorite } from '@cockpitai/store/navigation/useSideBarStore'

export async function getFavorites() {
  const response = await client.get<Favorite[]>('/favorite/vision')

  return response.data
}

export async function sendFavorite(favorite: Favorite) {
  const response = await client.post<Favorite>('/favorite/vision', favorite)

  return response.data
}

export async function deleteFavorite(id: string) {
  const response = await client.delete(`/favorite/vision/${id}`)

  return response.data
}
